import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const ConfiguredFeatureStyle = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	column-gap: 4rem;
	row-gap: 0.5rem;

	${breakPoints({
		'375': `
			grid-template-columns: auto auto;
		`,
	})}
`;
